import { getSafeUrl } from "../../../utils/helpers.js";
import { Fragment, useEffect, useState } from "react";

import Slider from "react-slick";

import UserImg from "../../../assets/images/user.png";

import "./TrustedPartnerSec.css";
import axios from "axios";
import { useStaticPageContent } from "../../../hooks/useStaticPageContent";
import { staticContentDefaults } from "../../../data/staticContentDefaults";
import CmsRichText from "../../common/CmsRichText";
import { mergeSplitHeadingHtml } from "../../../utils/cmsHeadingUtils";

const TrustedPartnerSec = () => {
    const pageContent = useStaticPageContent("home");
    const headerContent =
        pageContent?.trustedPartnersHeader ||
        staticContentDefaults.home.trustedPartnersHeader;
    const [data, setData] = useState([])
    const settings = {
        dots: true,
        slidesToShow: 1,
        infinite: true,
        speed: 1900,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 499,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    const fetchData = async () => {
        try {
            const res = await axios.get(
                `${import.meta.env.VITE_APP_BASE_URL}api/trusted-partner`, {}
            );
            setData(res?.data?.data);
        } catch (err) {
            console.log("Error while fetching security insurance fee", err?.message);
        }
    };
    useEffect(() => {
        fetchData();
    }, [])

    const handlePartnerClick = (url) => {
        const utmParams = `?utm_source=druyp&utm_medium=referral&utm_campaign=trusted_partner`;
        window.open(`${url}${utmParams}`, "_blank");
    };
    console.log(data);

    return (
        <Fragment>
            <div className="mt-5" id="trusted-partners-sec">
                <div className="container-fluid my-container">
                    <div className="row">
                        <div className="col-12 col-lg-12">
                            <div className="heading-sec new">
                                <h2>
                                    <CmsRichText as="span" value={mergeSplitHeadingHtml(headerContent)} />
                                </h2>
                                <p>
                                    <CmsRichText as="span" value={headerContent.description} />
                                </p>
                            </div>
                        </div>
                        <Slider {...settings}>
                            {data?.map((partner, index) => (
                                <div className="carousel-item" key={index}>
                                    <div className="slider-sec">
                                        <div className="slider-inner">
                                            <img
                                                src={getSafeUrl(partner.vendorImage)}
                                                alt={partner.name}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handlePartnerClick(partner.link)}
                                            />
                                            <div className="slider-content">
                                                <p>{partner.description}</p>
                                                <h3
                                                    style={{ cursor: "pointer", color: "#ff5c16" }}
                                                    onClick={() => handlePartnerClick(partner.link)}
                                                >
                                                    {partner.name}
                                                </h3>
                                                <p>{partner.company}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default TrustedPartnerSec;
